// Mobile thumbnail strip for the product gallery. Each [data-gallery-thumb] button scrolls the
// sibling [data-product-gallery] scroller to that slide; scrolling the gallery updates aria-current.
class SGalleryThumbs extends HTMLElement {
  #abort = null;
  #frame = 0;

  connectedCallback() {
    this.gallery = this.parentElement?.querySelector('[data-product-gallery]');
    if (!this.gallery) return;
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    this.thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => this.#goTo(Number(thumb.dataset.galleryThumb)), { signal });
    });
    this.gallery.addEventListener('scroll', () => this.#onScroll(), { signal, passive: true });
  }

  disconnectedCallback() {
    this.#abort?.abort();
    cancelAnimationFrame(this.#frame);
  }

  #goTo(index) {
    const slide = this.gallery.children[index];
    if (!slide) return;
    const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.gallery.scrollTo({ left: slide.offsetLeft - this.gallery.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    this.#setCurrent(index);
  }

  #onScroll() {
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(() => {
      const width = this.gallery.clientWidth || 1;
      const index = Math.round(Math.abs(this.gallery.scrollLeft) / width);
      this.#setCurrent(index);
    });
  }

  #setCurrent(index) {
    this.thumbs.forEach((thumb, i) => {
      if (i === index) {
        thumb.setAttribute('aria-current', 'true');
        const strip = thumb.closest('ul');
        if (strip) strip.scrollLeft = thumb.parentElement.offsetLeft - strip.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2;
      } else {
        thumb.removeAttribute('aria-current');
      }
    });
  }
}

if (!customElements.get('s-gallery-thumbs')) {
  customElements.define('s-gallery-thumbs', SGalleryThumbs);
}
